import { useTheme } from "@mui/material/styles";
import { InventoryMeasurementFormState } from "../types";
import { useTenantTranslation } from "hooks/formatters";
import {
  Box,
  CircularProgress,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { JSX, useMemo } from "react";
import { InventoryMeasurementFormMobile } from "./InventoryMeasurementFormMobile";
import { InventoryMeasurementFormDesktop } from "./InventoryMeasurementFormDesktop";
import { useInventoryMeasurement } from "./InventoryMeasurementProvider";

export const InventoryMeasurementForm: React.FC = () => {
  const { t } = useTenantTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { inventoryEstimate, inventoryMeasurementFormState } =
    useInventoryMeasurement();

  const body = useMemo((): JSX.Element => {
    if (!inventoryEstimate) {
      return (
        <Box sx={{ textAlign: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      );
    }
    switch (inventoryMeasurementFormState) {
      case InventoryMeasurementFormState.Pending:
        if (isMobile) {
          return (
            <InventoryMeasurementFormMobile
              inventoryEstimate={inventoryEstimate}
            />
          );
        } else {
          return (
            <InventoryMeasurementFormDesktop
              inventoryEstimate={inventoryEstimate}
            />
          );
        }
      case InventoryMeasurementFormState.Submitting:
        return (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              py: 8,
              gap: 3,
            }}
          >
            <CircularProgress size={60} />
            <Typography variant="h6" color="text.secondary">
              {t("creatingRecipe")}
            </Typography>
          </Box>
        );
      case InventoryMeasurementFormState.Submitted:
        return <Typography>{t("success")}</Typography>;
    }
    // eslint-disable-next-line @eslint-react/exhaustive-deps -- t is a translation function with unstable identity; body only needs to rebuild when form state, layout, or estimate data change
  }, [inventoryMeasurementFormState, isMobile, inventoryEstimate]);

  return (
    <>
      <Typography sx={{ mb: 3, color: theme.palette.text.secondary }}>
        {t("enterInventoryAdjustments")}
      </Typography>
      {body}
    </>
  );
};
